import { ChartOptions } from 'chart.js';

export const options: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        pointStyle: 'rect',
        usePointStyle: true
      }
    },
    tooltip: {
      callbacks: {
        title: (context) => context[0]?.label ?? '',
        label: (context) => `${context.dataset.label}: ${context.parsed.y}`,
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
    },
    y: {
      beginAtZero: true,
      ticks: { stepSize: 1 },
    },
  },
};
